import React from 'react';
import { Paper, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import OverlayChart from './OverlayChart';
import STLineChart from './STLineChart';
import ResultsChart from './ResultsChart';
import LineResultsChart from './LineResultsChart';

import { useMapContext } from '../Map/MapContext';
import LoadingLogo from '../Utils/LoadingLogo';
import { TimerSharp } from '@mui/icons-material';


const GraphPanel = () => {
    const {
        stormMode,
        selectedFeature,
        mapClickInfo,
        timeSeries,
        handleCloseDraggable,
        loading,
        outFileExists,
    } = useMapContext();

    const selectedFeatureData = selectedFeature.Data;
    const selectedLayer = mapClickInfo.selectedLayer;

    const rainfallData = timeSeries.rainfallData;
    const timeseriesData = timeSeries.timeseriesData;

    const rainfallSum = timeSeries.rainfallSum;
    const timeseriesSum = timeSeries.timeseriesSum;

    const newTimeseriesData = timeSeries.newTimeseriesData;
    const newTimeseriesSum = timeSeries.newTimeseriesSum;

    const infiltrationSum = timeSeries.infiltrationSum;

    if (!stormMode || !selectedFeatureData) return null;

    return (
        <div
        style={{
            position: 'absolute',
            top: 115,
            right: 15,
            width: '500px',
            height: '300px',
            backgroundColor: '#071317',
            opacity: 0.9,
            zIndex: 10,
            borderRadius: '5px',
        }}
        >
            <IconButton
                style={{ position: 'absolute', top: 0, right: 0, zIndex: 20 }}
                onClick={handleCloseDraggable}
            >
                <CloseIcon style={{ color: '#94cfec' }} fontSize="small" />
            </IconButton>

            <h4
                style={{
                    color: '#94cfec',
                    textAlign: 'left',
                    marginLeft: '20px',
                    marginBottom: '0px',
                }}
            >
                {selectedFeatureData.NAME} {selectedLayer === 'subcatchment' ? 'Runoff (cfs)' : 'Overflow (cfs)'}
            </h4>

            <div
                style={{
                    position: 'absolute',
                    top: '20px',
                    right: '45px',
                    bottom: '0px',
                }}
            >
                {selectedLayer === 'subcatchment' && (
                    <Paper
                        elevation={3}
                        style={{
                            backgroundColor: '#071317',
                            width: '100px',
                            height: '60px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            marginBottom: '10px',
                            marginRight: '15px',
                        }}
                    >
                        <div style={{ textAlign: 'center', color: '#94cfec', fontSize: '0.9em' }}>
                            💧 Precip: <br />
                            <b>{rainfallSum}</b>"
                        </div>
                    </Paper>
                )}

                {selectedLayer === 'subcatchment' && (<Paper
                    elevation={3}
                    style={{
                        backgroundColor: '#071317',
                        width: '100px',
                        height: '60px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginBottom: '10px',
                        marginRight: '15px',
                    }}
                >
                    <div style={{ textAlign: 'center', color: '#94cfec', fontSize: '0.9em' }}>
                        🌊 Runoff: <br />
                        <b>{timeseriesSum}</b> MG
                    </div>
                </Paper>)}

                {selectedLayer === 'subcatchment' && (<Paper
                    elevation={3}
                    style={{
                        backgroundColor: '#071317',
                        width: '100px',
                        height: '60px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginBottom: '10px',
                        marginRight: '15px',
                    }}
                >
                    <div style={{ textAlign: 'center', color: '#94cfec', fontSize: '0.9em' }}>
                        🌱 Infiltration: <br />
                        <b>{infiltrationSum}</b> MG
                    </div>
                </Paper>)}

                {selectedLayer !== 'subcatchment' && (<Paper
                    elevation={3}
                    style={{
                        backgroundColor: '#071317',
                        width: '100px',
                        height: '60px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginBottom: '10px',
                        marginRight: '15px',
                    }}
                >
                    <div style={{ textAlign: 'center', color: '#94cfec', fontSize: '0.9em' }}>
                        🌊 Overflow: <br />
                        <b>{timeseriesSum}</b> MG
                    </div>
                </Paper>)}

                
            </div>

            <div
                style={{
                    display: 'flex',
                    height: '100%',
                    width: '100%',
                    position: 'relative',
                    marginTop: '0px',
                    marginBottom: '0px',
                }}
            >
                {loading ? (<LoadingLogo />) : (timeseriesData && timeseriesData.x ? (
                        selectedLayer === 'subcatchment' ? (
                            outFileExists && newTimeseriesData && rainfallData ? (
                                <ResultsChart x={timeseriesData.x} y1={timeseriesData.y} y2={rainfallData.y} y3={newTimeseriesData.y} />
                            ) : ( rainfallData ? (
                                <OverlayChart x={timeseriesData.x} y1={timeseriesData.y} y2={rainfallData.y} />
                                ) : (
                                    <LoadingLogo />
                                )
                            )
                        ) : (
                            outFileExists && newTimeseriesData ? (
                                <LineResultsChart x={timeseriesData.x} y={timeseriesData.y} y2={newTimeseriesData.y} selectedLayer={selectedLayer} />
                            ) : (
                                <STLineChart x={timeseriesData.x} y={timeseriesData.y} selectedLayer={selectedLayer} />
                            )
                        )
                    ) : (<LoadingLogo />)
                )}
            </div>
        </div>
    );
};

export default GraphPanel;
